export const ReportIcon = ({ width = 112, height = 156 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 112 156"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M83.2874 106.903C85.1364 105.066 88.1005 105.066 89.9496 106.903L102.171 116.768H102.383C104.855 119.267 104.855 123.318 102.383 125.818C99.9104 128.317 95.9017 128.317 93.4292 125.818L83.2874 114.194L82.9025 113.76C82.1856 112.852 81.7896 111.721 81.7896 110.548C81.7896 109.18 82.3286 107.868 83.2874 106.903ZM49.5943 32.0146C60.4773 32.0146 70.9145 36.3844 78.6099 44.1626C86.3053 51.9408 90.6285 62.4903 90.6285 73.4904C90.6285 96.3968 72.2569 114.966 49.5943 114.966C26.9317 114.966 8.56006 96.3968 8.56006 73.4904C8.56006 50.584 26.9317 32.0146 49.5943 32.0146Z"
      fill="#525252"
    />
  </svg>
);
